export default __webpack_public_path__ + "static/media/Silver.feb4f606.svg";